import { render } from "./m-common-swiper.vue?vue&type=template&id=5d4c32bb&scoped=true"
import script from "./m-common-swiper.vue?vue&type=script&lang=js"
export * from "./m-common-swiper.vue?vue&type=script&lang=js"

import "./m-common-swiper.vue?vue&type=style&index=0&id=5d4c32bb&lang=scss&scoped=true"

import exportComponent from "D:\\changDa\\w3c\\www-clothing\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5d4c32bb"]])

export default __exports__